/**
 * A full page load to `path`, for the moments a client-side route change is not
 * enough — chiefly right after sign-in, where every provider has to pick up the
 * freshly minted session cookie rather than a patched SPA state.
 *
 * Its own module so tests can observe the navigation: jsdom defines
 * `window.location` and its methods as non-configurable, so neither swapping
 * the object nor spying on `assign`/`replace` takes.
 */
export function hardNavigate(path: string): void {
  window.location.assign(path);
}

/**
 * The same full load, but replacing the current history entry, so Back does
 * not return to the page being left. Sign-out uses it: Back onto a page that
 * rendered the signed-in state would show stale account data.
 */
export function hardReplace(path: string): void {
  window.location.replace(path);
}

/**
 * Load the page again. The guest checkout's Try again when Stripe.js was
 * blocked: Stripe's <Elements> cannot take a new Stripe once mounted, so a
 * fresh load is the only retry, and the guest draft keeps what was typed.
 */
export function hardReload(): void {
  window.location.reload();
}
